import { Link } from "react-router-dom";
import HeaderScreen from "./layout/header";
import FooterScreen from "./layout/footer";
import Redalert404 from "@/../../public/images/Red-alert-404-design.png";


const NotFound = () => {
  return (
    <>

      <HeaderScreen />
      <section className="nocontent-holder common-padd">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="nocontent-info">
                <div className="nocontent-info-img">
                  <img src={Redalert404} alt="logo" />
                </div>
                <h1>Page Not Found</h1>
                <p>The page you are looking for does not exist.</p>
                <Link className="btn" to="/">Go to Home</Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      <FooterScreen />

    </>
  );
};

export default NotFound;
